/**
 * 答题前学习页 · 开始答题热点
 */

export function parseStudyStartHotspot(raw) {
  if (!raw) return null
  let obj = raw
  if (typeof raw === 'string') {
    try {
      obj = JSON.parse(raw)
    } catch (e) {
      return null
    }
  }
  if (!obj || typeof obj !== 'object') return null
  const pi = parseInt(obj.pointIndex, 10)
  const num = (v, d) => {
    const n = parseFloat(v)
    return Number.isFinite(n) ? n : d
  }
  const out = {
    left: num(obj.left, 35),
    top: num(obj.top, 80),
    sizeWidth: num(obj.sizeWidth, 30),
    sizeHeight: num(obj.sizeHeight, 8),
    label: obj.label != null ? String(obj.label) : '开始答题',
    fontSize: num(obj.fontSize, 28),
    color: obj.color || '#ffffff',
    fontWeight: obj.fontWeight === 'bold' ? 'bold' : 'normal',
    textAlign: obj.textAlign || 'center',
    bgColor: obj.bgColor || '#409eff',
    borderRadius: num(obj.borderRadius, 8)
  }
  if (Number.isFinite(pi) && pi > 0) {
    out.pointIndex = pi
  }
  return out
}

function pickStudyRules(quiz) {
  if (!quiz || typeof quiz !== 'object') return null
  if (quiz.paperRules && typeof quiz.paperRules === 'object') {
    return quiz.paperRules
  }
  if (quiz.studyPageIndex != null || quiz.studyStartHotspotJson != null) {
    return quiz
  }
  return null
}

function normalizeStudyHotspotJsonRaw(rawJson) {
  if (rawJson == null || rawJson === '') return null
  if (typeof rawJson === 'object') {
    try {
      return JSON.stringify(rawJson)
    } catch (e) {
      return null
    }
  }
  return String(rawJson).trim() || null
}

export function resolveQuizStudyGate(quiz) {
  const rules = pickStudyRules(quiz)
  if (!rules) return null
  const pageIndex = parseInt(rules.studyPageIndex, 10)
  const rawJson = normalizeStudyHotspotJsonRaw(rules.studyStartHotspotJson)
  if (!Number.isFinite(pageIndex) || pageIndex < 0 || !rawJson) return null
  const hotspot = parseStudyStartHotspot(rawJson)
  if (!hotspot) return null
  return { studyPageIndex: pageIndex, startHotspot: hotspot }
}

/** 从限次缓存 + 弹窗 payload 等多处解析学习页门禁 */
export function resolveQuizStudyGateFromSources(quiz, payload) {
  let gate = resolveQuizStudyGate(quiz)
  if (!gate && payload) {
    gate = resolveQuizStudyGate(payload)
  }
  return gate
}
